import { ComponentType, SVGProps } from "react";
import AmericanExpressIcon from "../../../../public/icons/american-express.svg";
import DinersClubIcon from "../../../../public/icons/diners-club.svg";
import DiscoverIcon from "../../../../public/icons/discover.svg";
import JcbIcon from "../../../../public/icons/jcb.svg";
import MastercardIcon from "../../../../public/icons/mastercard.svg";
import UnionPayIcon from "../../../../public/icons/union-pay.svg";
import VisaIcon from "../../../../public/icons/visa.svg";

export const CARD_BRAND_ICONS: Record<
  string,
  ComponentType<SVGProps<SVGSVGElement>>
> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  american_express: AmericanExpressIcon,
  discover: DiscoverIcon,
  diners_club: DinersClubIcon,
  jcb: JcbIcon,
  union_pay: UnionPayIcon,
};
